export const GET_SCHEME = '/smarttech/v1/schemes'
export const GET_CARD = '/smarttech/v1/card'
export const FRAUDULENT = '/smarttech/v1/fraudulent'

export const VERIFY_CODE = '/smarttech/v1/auth/login'
export const SEND_CODE = '/smarttech/v1/auth/request-code'
export const GET_PROFILE = '/smarttech/v1/auth/user/profile'
